import './App.css';
import MainLayout from "./components/MainLayout";

function App() {
  return (
    <div className="App">
      <MainLayout/>
    </div>
  );
}

export default App;
